import graphql__7adeb3ec822b932015ed from "./__generated__/UnsubscribeMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__7adeb3ec822b932015ed;

function unsubscribe(id, onCompleted) {
  const variables = {
    subscribableId: id
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { unsubscribe };
